import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import ResultsList from '../components/ResultsList';
import { getProcessedData } from '../services/mailchimp';

const Home = () => {
  console.log('Home mounted');
  const [data, setData] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const processedData = await getProcessedData();
      
      // Calculate total stats
      const totalChildren = Object.values(processedData).reduce(
        (sum, provincie) => sum + provincie.count, 
        0
      );
      const totalSchools = Object.values(processedData).reduce(
        (sum, provincie) => sum + Object.keys(provincie.gemeentes).reduce(
          (gemeenteSum, gemeente) => gemeenteSum + Object.keys(provincie.gemeentes[gemeente].schools).length,
          0
        ),
        0
      );

      setStats({
        children: totalChildren,
        schools: totalSchools
      });
      setData(processedData);
    };

    fetchData();
  }, []);

  if (!data) return <div className="loading">Loading...</div>;

  return (
    <Layout 
      region="Nederland" 
      stats={stats}
    >
      <div className="prompt">
        <p>Selecteer je provincie om meer data per gemeente te zien</p>
      </div>
      <div className="break"></div>
      <ResultsList 
        items={data} 
      />
    </Layout>
  );
};

export default Home;